<template>
    <div>
        <top-navbar></top-navbar>
<div>
 

<div class=" background_color">
  <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/issuetracking/index">
  <span v-if="details && details[1] && details[1].Home">{{ details[1].Home }}</span>
</router-link> <span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Customer<span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Issue Tracking<span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/issuetracking/index"><span v-if="details && details[4] && details[4]['Manage Issue']">{{details[4]['Manage Issue']}}</span> </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> <span v-if="details && details[51] && details[51]['Create Issue Tracking']">{{ details[51]['Create Issue Tracking'] }}</span></h6>
    <div class="container-fluid">
<div class="card bdr-rad2 mt-1 shadow p-2 ">
<div class="card-body">
  <form @submit.prevent="SaveIssue()" enctype="multipart/form-data">

    <div class="row">


<div class="col-md-3">
  <div class="form-group required">
          <label class="custom-label" style="font-size: small;">First name</label>
          <input   v-model="issue.first_name" class="form-control" >

       
  </div>
</div>
<div class="col-md-3">
  <div class="form-group required">
          <label class="custom-label" style="font-size: small;">Surename</label>
          <input   v-model="issue.surname" class="form-control" >

       
  </div>
</div>
<div class="col-md-3">
  <div class="form-group required">
          <label class="custom-label" style="font-size: small;">Email Adress</label>
          <input   v-model="issue.email" class="form-control" >

       
  </div>
</div>
<div class="col-md-3">
  <div class="form-group required">
          <label class="custom-label" style="font-size: small;">Mobile Number</label>
          <input   v-model="issue.mobile" class="form-control" >

       
  </div>
</div>

</div>

<div class="row">

<div class="col-md-3">
  <div class="form-group required">
          <label class="custom-label font-size_def" style="font-size: small;">Description </label>
          <textarea  v-model="issue.description" class="form-control" rows="3" required></textarea>
  </div>
</div>
<div class="col-md-3">
  <div class="form-group required">
          <label class="custom-label font-size_def" style="font-size: small;">Address </label>
          <textarea  v-model="issue.address" class="form-control" rows="3" required></textarea>
  </div>
</div>

<div class="col-md-3">
  <div class="form-group ">
          <label class="custom-label " style="font-size: small;">Feedback on the case </label>
          <v-select class="font-size_def" label="label" :options="feedback" v-model="issue.feedback"></v-select>
  </div>
</div>





</div>




 

  <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
  
  <div class="d-flex  ">
  
  </div>
  <div class="d-flex  ">
    <button  type="submit" class="btn btn-sm  btn-outline-primary mb-1 font-size_def bdr-rad bdr-rad">Create</button>
  </div>
  </div>



</form>
</div>
</div>
</div>
<br>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'
  import vSelect from 'vue-select'

  export default {
   

    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        id:this.$route.query.id,
        file: null,
        issue:{
            'description':'',
            'Latitude':'',
            'Longitude':'',
        },
        issue_det:[],
        aprts:[],
        errors: {},
        mainLoadding:false,
        mainmessage:'',
        subLoadding:false,
        submessage:'',
        searchAddress: '',
        mainscats:[],
        subcats:[],
        repots:[],
        file_atach:{},
        loadingdisable: false,
        images: [],
        details: [],
        feedback:[
        { label: 'Feedback via e-mail', value: 'Email' },
        { label: 'Feedback via SMS', value: 'SMS' },
        ],
        marker: null,
        map: null,
        clickedLocation: null,
      
        geocoder: null, 
        autocomplete: null, // To handle address autocomplete
        infoModal1: {
          id: 'info-modal1',
          title: '',
          content: [],
        },
        infoModal2: {
          id: 'info-modal2',
          title: '',
          content: [],
        },

        // variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        // headerBgVariant: 'mycoolor',
        // headerTextVariant: 'light',
        
      }

    },
    created(){
      this.loadlanguage();
    },
    mounted(){
 
 
  this.loadSplit();
 

  
  
 
    },
methods : {

  validate(){
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // const mobilePattern = /^\+46\d{2}\d{3}\d{4}$/; 
    // const mobilePattern = /^(?:\+47\d{8}|0\d{9})$/;
   // const mobilePattern = /^(?:\+46|0)\d{9}$/;
    // const mobilePattern = /^(?:\+46|0)([ -]?\d){9}$/;
      this.errors = {};
      if(this.issue.maincat == null){
        this.$set(this.errors, 'maincat', "Main Category field is required");
      }
      if(this.issue.subcat == null){
        this.$set(this.errors, 'subcat', "Sub Category field is required");
      }
      if(this.searchAddress== null){
        this.$set(this.errors, 'searchAddress', "The position of the case is required");
      }
      if(this.issue.subcat == null){
        this.$set(this.errors, 'subcat', "Sub Category field is required");
      }
      if(this.issue.feedback == null){
        this.$set(this.errors, 'feedback', "Feedback on the case field is required");
      }
      // if(this.issue.first_name == null){
      //   this.$set(this.errors, 'first_name', "First name is required");
      // }
      // if(this.issue.surname == null){
      //   this.$set(this.errors, 'surname', "Surename is required");
      // }
      if (!emailPattern.test(this.issue.email)) {
        this.$set(this.errors, 'email', "Please enter a valid email address");
      }
    
      if (!this.issue.mobile) {
        this.$set(this.errors, 'mobile', "Mobile number is required");
    } else {
        try {
          const phoneNumber = libphonenumber.parsePhoneNumber(this.issue.mobile, 'SE'); // 'SE' for Sweden

// Validate number and prefix
if (phoneNumber.isValid() && phoneNumber.country === 'SE') {
  const validPrefixes = ['4670', '4671', '4672', '4673', '4676', '4679'];
  const prefix = phoneNumber.number.slice(1, 5); // Extract "+467x"

  if (!validPrefixes.includes(prefix)) {
    addError('mobile', "Invalid Swedish mobile number.");
  }
} else {
  addError('mobile', "Please enter a valid mobile number");
}
        } catch (error) {
            this.$set(this.errors, 'mobile', "Please enter a valid mobile number");
        }
    }
      // if(this.squatation.customer_contact == null){
      //   this.$set(this.errors, 'customerContactError', "Customer Contact field is required");
      // }
      // if(this.sales == null){
      //   this.$set(this.errors, 'salespeoplesError', "Sales Person field is required");
      // }
      // if(this.quotation.id_brand == null){
      //   this.$set(this.errors, 'idbrandError', "Brand field is required");
      // }
     },


     initializeMap() {
  const defaultLocation = { lat: 59.3287, lng: 18.2507 }; // Default location (Sweden)

  // Define Sweden's bounds using LatLngBounds
  const swedenBounds = new google.maps.LatLngBounds(
    new google.maps.LatLng(55.005, 11.0274), // Southwest corner of Sweden
    new google.maps.LatLng(69.1062, 24.1553)  // Northeast corner of Sweden
  );
  
  // Create a map instance centered in Sweden
  const mapDiv = document.getElementById("map");
  console.log(mapDiv)
      if (mapDiv) {
        this.map = new google.maps.Map(mapDiv, {
          center: defaultLocation,
          zoom: 12,
          restriction: {
            latLngBounds: swedenBounds,
            strictBounds: false,
          },
        });

    

        this.geocoder = new google.maps.Geocoder();
        const input = this.$refs.autocomplete;
        this.autocomplete = new google.maps.places.Autocomplete(input, {
          componentRestrictions: { country: 'se' },
        });

        // Set up event listeners
        this.autocomplete.addListener("place_changed", this.handlePlaceSelect);
        this.map.addListener("click", (event) => {
          const lat = event.latLng.lat();
          const lng = event.latLng.lng();
          const clickedLocation = new google.maps.LatLng(lat, lng);

          if (swedenBounds.contains(clickedLocation)) {
            this.updateMarker(lat, lng);
            this.reverseGeocode(lat, lng);
          } else {
            alert("Selected location is outside of Sweden.");
          }
        });

        this.issue_det.forEach((issue) => {
  const position = { lat: parseFloat(issue.latitude), lng: parseFloat(issue.longitude) };
 
 let markerIcon = null;
  if (issue.id == this.id) {
  
    

    markerIcon = {
      url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png', // URL for green icon
      scaledSize: new google.maps.Size(40, 40), // Optional: Adjust the size
    };
  }

  if (swedenBounds.contains(position)) {
    const marker = new google.maps.Marker({
      position,
      map: this.map,
       icon: markerIcon,
    });

    // Info window to display on hover
    let statusHtml = ''; // Initialize statusHtml

if (issue.statusvalue === 1) {
  statusHtml = `<span style="color:red;">${issue.status}</span>`;
} else if (issue.statusvalue === 42) {
  statusHtml = `<span style="color:#ee68f9;">${issue.status}</span>`;
} else if (issue.statusvalue === 49) {
  statusHtml = `<span style="color:green;">${issue.status}</span>`;
} else if (issue.statusvalue === 21) {
  statusHtml = `<span style="color:green;">${issue.status}</span>`;
}else if (issue.statusvalue === 51) {
  statusHtml = `<span style="color:#f8a081;">${issue.status}</span>`;
}

let infoWindowContent;
if(issue.statusvalue === 52){
  infoWindowContent = `
  <div>
    <h5 style="color:#007bff;"> ${issue.tiketnum}</h5>
   
  <span style="font-size:14px;"><b>
     ${issue.address}.<br>
   
  </span>
  </div>
`; 
}else{
  infoWindowContent = `
  <div>
    <h5 style="color:#007bff;">${this.details[138]['Case']} ${issue.tiketnum}</h5>
   
  <span style="font-size:14px;"><b>
     ${issue.address}.<br>
    <strong>${this.details[124]['Ticket']} #:</strong> ${issue.tiketnum}<br>
    <strong>${this.details[139]['Category']}:</strong> ${issue.maincat}<br>
    <strong>${this.details[17]['Sub Category']}:</strong> ${issue.msubcat}<br><br>
    <strong>${this.details[22]['Status']}:</strong><b> ${statusHtml}</b><br></b>
  </span>
  </div>
`; 
}

// Construct the InfoWindow content


    const infoWindow = new google.maps.InfoWindow({
    
      content: infoWindowContent,
    });

 


    // Show info window on mouseover
    marker.addListener("mouseover", () => {
      infoWindow.open(this.map, marker);
    });

    // Hide info window on mouseout
    marker.addListener("mouseout", () => {
      infoWindow.close();
    });
    marker.addListener("click", () => {
      this.issue.lat = issue.latitude;
      this.issue.lng = issue.longitude;
      this.searchAddress = issue.address;

      // Optionally, center the map on the clicked marker
    
    });
  } else {
    console.warn(`Issue ID ${issue.id} is outside Sweden and won't be displayed.`);
  }
});
        

      } else {
        console.error("Map div not found");
      }

  // Reverse Geocoder instance to get address from lat/lng
  this.geocoder = new google.maps.Geocoder();
  
  // Autocomplete instance restricted to Sweden
  const input = this.$refs.autocomplete; // Reference to the search input
  this.autocomplete = new google.maps.places.Autocomplete(input, {
    componentRestrictions: { country: 'se' },  // Restrict autocomplete to Sweden
  });

  // When a place is selected from the autocomplete dropdown
  this.autocomplete.addListener('place_changed', this.handlePlaceSelect);

  // Add map click listener to load address and lat/lng
  this.map.addListener('click', (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();

    // Check if the clicked point is within Sweden's bounds
    const clickedLocation = new google.maps.LatLng(lat, lng);
    if (swedenBounds.contains(clickedLocation)) {
      // Update lat/lng inputs and place marker
      this.updateMarker(lat, lng);

      // Reverse geocode to get the address
      this.reverseGeocode(lat, lng);
    } else {
      alert('Selected location is outside of Sweden.');
    }
  });
},

// Handle place selection from the dropdown
handlePlaceSelect() {
  const place = this.autocomplete.getPlace();
  if (!place.geometry) {
    alert("No geometry found for this place");
    return;
  }

  // Get the location's latitude and longitude
  const location = place.geometry.location;
  const lat = location.lat();
  const lng = location.lng();

  // Check if the selected place is within Sweden
  const swedenBounds = new google.maps.LatLngBounds(
    new google.maps.LatLng(55.005, 11.0274), // Southwest corner of Sweden
    new google.maps.LatLng(69.1062, 24.1553)  // Northeast corner of Sweden
  );

  if (swedenBounds.contains(location)) {
    // Update lat/lng fields
    this.issue.lat = lat;
    this.issue.lng = lng;

    // Populate search input with formatted address
    this.searchAddress = place.formatted_address;

    // Update map and marker
    this.updateMap(location);
  } else {
    alert('Selected place is outside of Sweden.');
  }
},

// Update map, lat/lng fields, and place marker
updateMap(location) {
  this.map.setCenter(location);

  const lat = location.lat();
  const lng = location.lng();

  // Update lat/lng fields
  this.issue.lat = lat;
  this.issue.lng = lng;

  // Update marker position
  this.updateMarker(lat, lng);
},

// Place or move the marker on the map
updateMarker(lat, lng) {
  const position = { lat, lng };

  if (this.marker) {
    this.marker.setPosition(position);
  } else {
    this.marker = new google.maps.Marker({
      position,
      map: this.map,
    });
  }

  // Update lat/lng in inputs
  this.issue.lat = lat;
  this.issue.lng = lng;
},

// Reverse geocode lat/lng to get address and set it to the input
reverseGeocode(lat, lng) {
  const latlng = { lat, lng };
  this.geocoder.geocode({ location: latlng }, (results, status) => {
    if (status === 'OK' && results[0]) {
      // Check if the result is within Sweden
      const swedenBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(55.005, 11.0274), // Southwest corner of Sweden
        new google.maps.LatLng(69.1062, 24.1553)  // Northeast corner of Sweden
      );

      const resultLocation = results[0].geometry.location;
      if (swedenBounds.contains(resultLocation)) {
        // Populate the search box with the formatted address
        this.searchAddress = results[0].formatted_address;
      } else {
        alert('Geocoded address is outside of Sweden.');
      }
    } else {
      alert('Geocoder failed: ' + status);
    }
  });
},


    

handleFileChange(event) {
      const files = event.target.files;
      if (!files.length) return;

      // Ensure the total number of images doesn't exceed 3
      if (this.images.length + files.length > 3) {
        alert("You can only upload up to 3 images.");
        return;
      }

      Array.from(files).forEach((file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          // Add the new file to the `images` array
          this.images.push({ url: e.target.result, file, isUploaded: false });
        };
        reader.readAsDataURL(file);
      });

      // Reset file input value
      event.target.value = null;
    },

    removeImage(index) {
      this.images.splice(index, 1); // Remove the image from the array
    },


    async loadSplit() {
    
  
   
    try {
      const { data} = await  axios.get('/issuetracking/loadsplit?id='+this.id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.issue.description = data.issue.description;
      
       this.issue.address = data.issue.address;
       this.issue.first_name = data.issue.first_name;
       this.issue.surname = data.issue.surname;
       this.issue.email = data.issue.email;
       this.issue.mobile= data.issue.mobile;
       this.issue.feedback= data.issue.feedback;

    //    this.images = [
    //   { url: data.uploadedFile1, isUploaded: true },
    //   { url: data.uploadedFile2, isUploaded: true },
    //   { url: data.uploadedFile3, isUploaded: true },
    // ].filter((image) => image.url);
     
       
      
    } catch (error) {
      console.log(error.response);
    }
  },




  async SaveIssue() {
   console.log( this.images);
   try {
      const { data} = await  axios.post('/issuetracking/create',{userid:this.userid,issue:this.issue},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.status = data.status;
       if(this.status == 200){
        this.$router.push('/issuetracking/index');
       }
      
    } catch (error) {
      console.log(error.response);
    }
  },

  

  

  async loadlanguage() {
    
    console.log(this.issue);
   
    try {
      const { data} = await  axios.get('/user/loadlanguage',{
        headers:{
          // 'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.details = data.details;
      
       console.log(this.details);
       
      
    } catch (error) {
      console.log(error.response);
    }
  },

  async submessageLoad() {
    
    console.log(this.issue.subcat.message_status);
     if(this.issue.subcat.message_status == 1){
      this.infoModal2.content =  this.issue.subcat.message
      this.$root.$emit('bv::show::modal', this.infoModal1.id);
     }


    },


 
      
    



  
 

 


 





  
  
  


},

    components :{
        ContentFooter,
        TopNavbar,
        'v-select': vSelect,
    },
  }

</script>
<style >
.gm-ui-hover-effect {
  display: none !important;
}
/* .modal .modal-content {
margin-top: 20% !important;
} */

.image-preview {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.image-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}
.image-container {
  position: relative;
  width: 100px;
  height: 100px;
}
.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.remove-btn {
  position: absolute;
  top: -5px;
  right: -5px;
  background: none;
  border: none;
  color: red;
  font-size: 16px;
  cursor: pointer;
}
.remove-btn i {
  font-size: 20px;
  color: red;
}
.remove-btn:hover i {
  color: darkred;
}
.info-message {
  color: red;
  font-size: small;
}
</style>